export default __webpack_public_path__ + "static/media/close-grey.ab8b3341.svg";